const HowToX = () => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">How to X</h3>
        <p className="text-muted-foreground mt-2 text-sm">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
      </div>

      <div className="rounded-md border p-4">
        <h4 className="text-sm font-medium">X Overview</h4>
        <p className="text-muted-foreground mt-1 text-sm">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget
          feugiat elit. Duis non magna vel purus commodo tincidunt sit amet in
          lectus.
        </p>
      </div>

      <div className="rounded-md border p-4">
        <h4 className="text-sm font-medium">X Configuration</h4>
        <p className="text-muted-foreground mt-1 text-sm">
          Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
          posuere cubilia curae; Donec lacinia, nisi id fringilla posuere, orci
          ligula varius nunc, eu gravida diam purus at leo.
        </p>
      </div>

      <div className="rounded-md border p-4">
        <h4 className="text-sm font-medium">Troubleshooting X</h4>
        <p className="text-muted-foreground mt-1 text-sm">
          Curabitur ultricies dapibus turpis, eu lobortis magna. Nulla facilisi.
          Etiam accumsan, nisl sit amet finibus auctor, lorem nisi luctus nunc,
          a finibus mauris libero in diam.
        </p>
      </div>

      <div className="mt-6">
        <h4 className="mb-2 text-sm font-medium">Video Tutorial</h4>
        <div className="relative aspect-video overflow-hidden rounded-md border">
          <div className="absolute size-full animate-pulse bg-slate-950/50" />
          <iframe
            title="Tutorial"
            src="https://www.loom.com/embed/c55c524ab7bc4ab6b3a5868adaed7c3e?hideEmbedTopBar=true"
            allowFullScreen
            className="absolute size-full"
          />
        </div>
        <p className="text-muted-foreground mt-2 text-xs">
          Watch this helpful video guide to get started with X
        </p>
      </div>
    </div>
  );
};

export default HowToX;
